import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router'; // importa Router
import { SnapshotRequestService } from '../service/snapshot-request.service';

@Injectable()
export class SnapshotInterceptor implements HttpInterceptor {
    constructor(
        private readonly messageService: MessageService,
        private snapshotService: SnapshotRequestService,
        private router: Router // inietta Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUrl = this.router.url; // URL del browser
        let modifiedReq = req;

        if (currentUrl.includes('risk-assessment') && !req?.body?.query?.includes('campaigns') && !req?.body?.query?.includes('snapshotsByYear')) {
            const snapshotId = this.snapshotService.getHeaderValue() ?? localStorage.getItem('snapshotVersion');

            if (snapshotId) {
                modifiedReq = req.clone({
                    setHeaders: {
                        'X-SNAPSHOT-SCHEMA': snapshotId
                    }
                });
            }
        } else if (this.snapshotService.getHeaderValue() !== null) {
            this.snapshotService.setHeaderValue(null)
            localStorage.removeItem('snapshot');
        }

        return next.handle(modifiedReq);
    }
}
